export const SplitToLines = (param: string) => {
 return param.split("").map((e) => (e == `\\` ? <br /> : <>{e}</>));
};
